import { useState, useEffect } from "react";
import { KBD } from "../utils/Keybindings";
import { useTabs } from "../hooks/useTabs";
import { pubCall } from "../utils/PubSub";
import Spin from "../ui/Spin";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import { listen } from "../hooks/Listener";
import { showError, showMessage } from "../ui/Message";

import { createModal } from "../hooks/createModal";

export default function GlobalDiscount(props) {

    const { controller = "", route, state = {}, callback = () => { } } = props;
    const [loading, setLoading] = useState(false);

    const defaultTabs = [
        { help: "Change discounts that are currently", label: "From", key: "from", value: "" },
        { help: "Change discounts to", label: "To", key: "to", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "from");

    const changeDiscount = () => {
        pubCall("category.changeDiscount", { from: getVal("from"), to: getVal("to") }, (_s, _r) => {
            if (_s) {
                callback(true);
                showMessage("Discounts changed successfully");
            } else {
                showError(_r);
            }
        })
    }

    useEffect(() => {
        const el = refs?.current?.[index];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
        const action = [
            { key: KBD.ESCAPE, action: () => { callback(false) } },
            { key: KBD.ENTER, action: () => { index === "to" ? changeDiscount() : next()} },
            { key: KBD.TAB, action: () => { next() } },
            { key: KBD.ARROW_DOWN, action: () => { next() } },
            { key: KBD.ARROW_UP, action: () => { prev() } },
        ]
        const cleanup = listen(controller, route, action, false, [KBD.ESCAPE, KBD.ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB]);
        return cleanup;
    }, [index, tabs])

    return (
        <Spin loading={loading} style={{ "padding": " 0 15px" }}>
            <div style={{ "width": "360px" }}>
                <div style={{ "width": "360px" }}>
                    <div className="shim" /><div className="shim" />
                    <Space size={10}>
                        <Label width={300}>Change discounts that are currently</Label>
                        <Divider vertical />
                        <Input number={true} width={25} maxLength={2} {...editProps("from")} className={(index !== "from") ? "dim" : ""} />
                        <Label width={10}>to</Label>
                        <Divider vertical />
                        <Input number={true} width={25} maxLength={2} {...editProps("to")} className={(index !== "to") ? "dim" : ""} />
                    </Space>
                    <div className="shim" /><div className="shim" />
                </div>
            </div>
        </Spin>
    )
}